module.exports = __webpack_public_path__ + "static/media/001-Ueberzeugen_ID_25.7f721f31.mp3";